<h3 modal-title>Adicionar Carta</h3>

<div modal-body mat-dialog-content>
    <form [formGroup]="cartaFormGroup" (ngSubmit)="salvar()">
        <div class="profile-box friends" fxLayout="column">
            <div class="content">
                <div *ngIf="!parceiroConsorcioId">
                    <mat-error>{{getErrorBoletaFormMessage()}}</mat-error>
                    <br />
                </div>
                <div fxLayout="row" fxLayoutAlign="space-between">
                    <mat-form-field appearance="outline" floatLabel="always" fxFlex="48">
                        <mat-label>GRUPO</mat-label>
                        <input matInput formControlName="grupo" name="grupo" placeholder="GRUPO" required>
                        <mat-error *ngIf="cartaFormGroup.get('grupo')?.invalid">Grupo é um campo
                            obrigatório.</mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" floatLabel="always" fxFlex="48">
                        <mat-label>COTA</mat-label>
                        <input matInput formControlName="cota" name="cota" placeholder="COTA" required>
                        <mat-error *ngIf="cartaFormGroup.get('cota')?.invalid">Cota é um campo
                            obrigatório.</mat-error>
                    </mat-form-field>
                </div>

                <div fxLayout="row" fxLayoutAlign="space-between">
                    <mat-form-field appearance="outline" floatLabel="always" fxFlex="48">
                        <mat-label>Prazo Grupo</mat-label>
                        <input matInput type="number" formControlName="prazo_grupo" name="prazo_grupo"
                            placeholder="Prazo Grupo" required>
                        <mat-error *ngIf="cartaFormGroup.get('prazo_grupo')?.invalid">Prazo Grupo é um
                            campo obrigatório.</mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" floatLabel="always" fxFlex="48">
                        <mat-label>Taxa Administração</mat-label>
                        <input matInput placeholder="Taxa Administração"
                            formControlName="taxa_administrativa_grupo" currencyMask
                            [options]="{ prefix: '% ', thousands: '.', decimal: ',', align: 'center' }" />
                    </mat-form-field>
                </div>

                <div fxLayout="row" fxLayoutAlign="space-between">
                    <mat-form-field appearance="outline" floatLabel="always" fxFlex="48">
                        <mat-label>Data do Fechamento</mat-label>
                        <input matInput [matDatepicker]="picker_data_fechamento" formControlName="data_fechamento"
                            placeholder="Data do Fechamento" readonly>
                        <mat-datepicker-toggle matSuffix [for]="picker_data_fechamento"></mat-datepicker-toggle>
                        <mat-datepicker #picker_data_fechamento></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field appearance="outline" floatLabel="always" fxFlex="48">
                        <mat-label>Tabela Fechamento</mat-label>
                        <mat-select placeholder="Tabela Fechamento" formControlName="fechamento_id" required>
                            <mat-option value="">SELECIONE</mat-option>
                            <mat-option *ngFor="let item of listFechamentoConsorcio"
                                [value]="item.id">{{item.nome}}</mat-option>
                        </mat-select>
                        <mat-spinner diameter="20" *ngIf="loadingSpinnerFechamentoConsorcio"></mat-spinner>
                        <mat-error *ngIf="cartaFormGroup.get('fechamento_id')?.invalid">Tabela Fechamento
                            é um campo obrigatório.</mat-error>
                    </mat-form-field>
                </div>

                <div fxLayout="row" fxLayoutAlign="space-between">
                    <mat-form-field appearance="outline" floatLabel="always" fxFlex="48">
                        <mat-label>Desconto %</mat-label>
                        <input matInput placeholder="Desconto" formControlName="desconto" name="desconto" currencyMask
                            [options]="{ prefix: '% ', thousands: '.', decimal: ',', align: 'center' }" />
                    </mat-form-field>

                    <mat-form-field appearance="outline" floatLabel="always" fxFlex="48">
                        <mat-label>Data do Pagamento</mat-label>
                        <input matInput [matDatepicker]="picker_data_pagamento" formControlName="data_pagamento"
                            placeholder="Data do Pagamento"readonly>
                        <mat-datepicker-toggle matSuffix [for]="picker_data_pagamento"></mat-datepicker-toggle>
                        <mat-datepicker #picker_data_pagamento></mat-datepicker>
                    </mat-form-field>
                </div>

                <div fxLayout="row" fxLayoutAlign="space-between">
                    <mat-form-field appearance="outline" floatLabel="always" fxFlex="48">
                        <mat-label>Valor da Carta</mat-label>
                        <input matInput placeholder="Valor Carta" formControlName="valor_carta" currencyMask
                            [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'center' }" />
                    </mat-form-field>
                    <mat-form-field appearance="outline" floatLabel="always" fxFlex="48">
                        <mat-label>Status</mat-label>
                        <mat-select placeholder="Status" formControlName="status_id" name="status_id" required>
                            <mat-option value="">SELECIONE</mat-option>
                            <mat-option *ngFor="let item of listStatusCartaConsorcio"
                                [value]="item.id">{{item.nome}}</mat-option>
                        </mat-select>
                        <mat-spinner diameter="20" *ngIf="loadingSpinnerStatusCartaConsorcio"></mat-spinner>
                        <mat-error *ngIf="cartaFormGroup.get('status_id')?.invalid">Status é um campo
                            obrigatório.</mat-error>
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="space-between" *ngIf="isStatusContempladaFaturada()">
                    <mat-form-field appearance="outline" floatLabel="always" fxFlex="48">
                        <mat-label>Data de Contemplação</mat-label>
                        <input matInput [matDatepicker]="picker_data_contemplacao" formControlName="data_contemplacao"
                            placeholder="Data de Contemplação" readonly>
                        <mat-datepicker-toggle matSuffix [for]="picker_data_contemplacao"></mat-datepicker-toggle>
                        <mat-datepicker #picker_data_contemplacao></mat-datepicker>
                    </mat-form-field>
                </div>
                <div fxLayout="column" fxLayoutAlign="space-between" formArrayName="lances">
                    <div fxLayout="row wrap">
                        <h3>Lances</h3>
                    </div>
                    <div *ngFor="let lance of lances.controls; let i=index" fxFlex="100">
                        <div fxLayout="row" [formGroupName]="i">
                            <mat-form-field appearance="outline" floatLabel="always" fxFlex="42" class="mr-24">
                                <mat-label>Tipo de Lance</mat-label>
                                <mat-select placeholder="Tipo de Lance" formControlName="tipo_lance_id">
                                    <mat-option value="">SELECIONE</mat-option>
                                    <mat-option *ngFor="let item of listTipoLance"
                                        [value]="item.id">{{item.nome}}</mat-option>
                                </mat-select>
                                <!-- <mat-spinner diameter="20" *ngIf="loadingSpinnerTipoLance"></mat-spinner> -->
                                <!-- <mat-error *ngIf="formGroup.get('tipo_lance')?.invalid">Tipo de Lance é um campo
                                obrigatório.</mat-error> -->
                            </mat-form-field>
                            <mat-form-field appearance="outline" floatLabel="always" fxFlex="42">
                                <mat-label>Valor do Lance</mat-label>
                                <input matInput placeholder="valor" formControlName="valor_lance" currencyMask
                                    [options]="getOptionsTypeValue(i)" />
                                <!-- <mat-error *ngIf="formGroup.get('valor_lance')?.invalid">Valor do Lance é um campo
                                obrigatório.</mat-error> -->
                            </mat-form-field>
                            <div fxFlex="3" style="align-content: center;height: 64px;"
                                >
                                <button mat-icon-button color="red" matTooltip="REMOVER LANCE"
                                    class="add-product-button" type="button" (click)="removeLance(i)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                            <div fxFlex="3" style="align-content: center;height: 64px;"
                                *ngIf="lances.controls.length == (i+1)">
                                <button mat-icon-button color="white" matTooltip="ADICIONAR LANCE"
                                    class="add-product-button" type="button" (click)="addLance()">
                                    <mat-icon>add_circle</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div mat-dialog-actions model-footer>
    
            <button 
                mat-button 
                tabindex="2" 
                type="button"
                (click)="onNoClick()"
            >   
                Cancelar
            </button>
            
            <button 
                mat-button 
                type="submit" 
                tabindex="-1"
            >
                Salvar
            </button>
        </div>
    </form>
</div>